import { Record } from "../fable-library-js.4.29.0/Types.js";
import { class_type, record_type, string_type } from "../fable-library-js.4.29.0/Reflection.js";

export class BundleIcons extends Record {
    constructor(Filled, Regular) {
        super();
        this.Filled = Filled;
        this.Regular = Regular;
    }
}

export function BundleIcons_$reflection() {
    return record_type("FS.FluentUI.BundleIcons", [], BundleIcons, () => [["Filled", string_type], ["Regular", string_type]]);
}

export class Interop {
    constructor() {
    }
}

export function Interop_$reflection() {
    return class_type("FS.FluentUI.Interop", undefined, Interop);
}

//# sourceMappingURL=Utils.fs.js.map
